import { AttioPeopleResponse, TextValue } from '../attio.types';
import { BaseAttioService } from './BaseAttioService';

// Service-specific types
export interface AttioPeopleData {
  peopleId: string;
  name: string;
  jobTitle: string;
  email?: string;
  notes?: TextValue[];
}

export class AttioPeopleService extends BaseAttioService {
  constructor() {
    super('AttioPeopleService');
  }

  /**
   * Get people details by record ID
   */
  async getPeopleDetail(peopleRecordId: string): Promise<AttioPeopleResponse> {
    try {
      const response = await this.get<AttioPeopleResponse>(this.endpoints.retrievePeopleByRecordId(peopleRecordId));
      return response;
    } catch (error) {
      this.handleError(error, 'getPeopleDetail');
    }
  }

  /**
   * Get people data with extracted information
   */
  async getPeopleData(peopleRecordId: string): Promise<AttioPeopleData> {
    try {
      const response = await this.getPeopleDetail(peopleRecordId);
      const peopleData = response.data.values;

      return {
        peopleId: peopleRecordId,
        name: peopleData.name?.[0]?.full_name || '-',
        jobTitle: peopleData.job_title?.[0]?.value || '-',
        email: peopleData.email?.[0]?.value || '-',
        notes: peopleData.notes,
      };
    } catch (error) {
      this.handleError(error, 'getPeopleData');
    }
  }
}
